module.exports = __webpack_public_path__ + "static/media/task progress.f6b74a12.svg";